import {combineReducers} from 'redux';
import {
  setSelectedStag as setSelectedStagRef,
  createStag,
  getStagForCode as getStagForCodeAPI,
  getCodeForStag as getCodeForStagAPI,
  getUserStags as getUserStagsAPI,
  getUserCreatedStags as getUserCreatedStagsAPI,
  joinStag as joinStagAPI,
  updateStagAttendance as updateStagAttendanceAPI,
  registerUserStagsListener as registerUserStagsListenerAPI,
} from '../module/API';
import {
  registerPeopleListener,
  registerAgendaListener,
  registerHomepageListener,
  registerPointsListener,
  registerPollsListener,
  deregisterPeopleListener,
  deregisterAgendaListener,
  deregisterHomepageListener,
  deregisterPointsListener,
  deregisterPollsListener,
  networkStatusSelector,
} from './index';
import _get from 'lodash/get';
import config from '../config/core.json';
import {getItem} from '../module/LocalStorage';

// *** REDUCERS

export const selectedReducer = (state = {}, action) => {

  let newState;

  switch(action.type) {

    case 'SELECT_STAG':
      if ( (action.code && state && state.code && action.code !== state.code) || (action.stag && state && state.stag && action.stag !== state.stag) ) {
        newState = {
          code: action.code,
          stag: action.stag,
        };
      } else {
        newState = {
          ...state
        };
        if ( action.code ) newState.code = action.code;
        if ( action.stag ) newState.stag = action.stag;
      }
      return newState;

    case 'UPDATE_STAG_CODE':
      return {
        ...state,
        code: action.code,
      };

    default:
      return state;

  }

};

export const userStagsReducer = (state = {}, action) => {

  let newStags;

  switch(action.type) {

    case 'FETCH_USER_STAGS':
      return {
        ...state,
        fetching: true,
      };

    case 'STAG_CREATED':
      newStags = state.stags ? {...state.stags} : {};
      newStags[action.stag] = {
        created: Date.now(),
        title: _get(action, 'props.homepage.title', ''),
      };
      return {
        ...state,
        stags: newStags
      };

    case 'FETCH_USER_STAGS_SUCCESS':
      return {
        ...state,
        fetching: false,
        stags: action.stags,
      };

    default:
      return state;

  }

};

export const userCreatedStagsReducer = (state = [], action) => {

  switch(action.type) {

    case 'FETCH_USER_CREATED_STAGS_SUCCESS':
      return action.stags;

    default:
      return state;

  }

};

// *** MAIN REDUCER

export default combineReducers({
  selected: selectedReducer,
  userStags: userStagsReducer,
  userCreatedStags: userCreatedStagsReducer,
});

// *** SELECTORS

export const selectedStagSelector = (state) => state.selected ? state.selected.stag : null;
export const stagCodeSelector = (state) => state.selected ? state.selected.code : null;
export const userStagsSelector = (state, stag) => state.userStags.stags ? state.userStags.stags : {};
export const userCreatedStagsSelector = (state, stag) => state.userCreatedStags || [];
export const userIsAdminForStag = (state, stag) => (userCreatedStagsSelector(state).indexOf(stag) > -1);
export const fetchingUserStagsSelector = (state) => state.userStags.fetching ? true : false;
export const userHasJoinedStagSelector = (state) => (Object.keys(userStagsSelector(state)).indexOf(selectedStagSelector(state)) > -1);

// *** ACTIONS

export const getStagForCode = (code) => {
  let stag;
  return (dispatch, getState) => {
    // if we don't have a network connection, but we do have this info in local storage
    // then resolve straight away with the data we have, otherwise kick off the promise
    if ( !networkStatusSelector(getState()) ) {
      stag = getItem(config.localStorageKey + "_CODE_" + code);
      if ( stag && stag.length ) {
        return Promise.resolve(stag);
      }
    }
    return getStagForCodeAPI(code).then(stag => {
      return stag;
    });
  };
};

export const getCodeForStag = (stag) => {
  let stagData;
  return (dispatch, getState) => {
    // if we don't have a network connection, but we do have this info in local storage
    // then resolve straight away with the data we have, otherwise kick off the promise
    if ( !networkStatusSelector(getState()) ) {
      stagData = getItem(config.localStorageKey + "_" + stag);
      if ( stagData && stagData.length ) {
        stagData = JSON.parse(stagData);
        if ( stagData && stagData.code ) {
          dispatch({
            type: 'UPDATE_STAG_CODE',
            code: stagData.code,
          });
          return Promise.resolve(stagData.code);
        }
      }
    }
    return getCodeForStagAPI(stag).then(code => {
      dispatch({
        type: 'UPDATE_STAG_CODE',
        code
      });
      return code;
    });
  };
};

export const setSelectedStag = (stag) => {
  return (dispatch) => {
    setSelectedStagRef(stag);

    dispatch({
      type: 'SELECT_STAG',
      stag,
    });

    if ( stag ) {
      return {
        people: dispatch(registerPeopleListener(stag)),
        agenda: dispatch(registerAgendaListener(stag)),
        homepage: dispatch(registerHomepageListener(stag)),
        points: dispatch(registerPointsListener(stag)),
        polls: dispatch(registerPollsListener(stag)),
      };
    } else {
      return;
    }
  };
};

export const deregisterStagListeners = (listeners, stag) => {
  return (dispatch) => {
    setSelectedStagRef(null);

    if ( listeners ) {
      dispatch(deregisterPeopleListener(listeners.people, stag));
      dispatch(deregisterAgendaListener(listeners.agenda, stag));
      dispatch(deregisterHomepageListener(listeners.homepage, stag));
      dispatch(deregisterPointsListener(listeners.points, stag));
      dispatch(deregisterPollsListener(listeners.polls, stag));
    }
  };
};


export const createNewStag = (props) => {
  return (dispatch) => {
    return createStag(props).then(({id, code}) => {
      dispatch({
        type: 'SELECT_STAG',
        stag: id,
        code,
      });
      dispatch({
        type: 'STAG_CREATED',
        stag: id,
        props
      });
      return {id, code};
    });
  }
};

export const getUserStags = () => {
  return (dispatch) => {
    dispatch({
      type: 'FETCH_USER_STAGS',
    });
    getUserCreatedStagsAPI().then(userCreatedStags => {
      dispatch({
        type: 'FETCH_USER_CREATED_STAGS_SUCCESS',
        stags: Object.keys(userCreatedStags),
      });
    });
    getUserStagsAPI().then(stags => {
      dispatch({
        type: 'FETCH_USER_STAGS_SUCCESS',
        stags,
      });
    });
  };
};

export const joinStag = (id) => {
  return (dispatch) => {
    dispatch({
      type: 'JOIN_STAG_REQUEST',
    });
    return joinStagAPI(id).then(() => {
      dispatch({
        type: 'JOIN_STAG_SUCCESS',
        stag: id,
      });
    });
  };
};

export const updateStagAttendance = (attending) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_STAG_ATTENDANCE_REQUEST',
    });
    updateStagAttendanceAPI({attending}).then(() => {
      dispatch({
        type: 'UPDATE_STAG_ATTENDANCE_SUCCESS',
      });
    });
  };
};

export const registerUserStagsListener = () => {
  return (dispatch) => {
    registerUserStagsListenerAPI((joinedStags, createdStags) => {
      dispatch({
        type: 'FETCH_USER_CREATED_STAGS_SUCCESS',
        stags: Object.keys(createdStags),
      });
      dispatch({
        type: 'FETCH_USER_STAGS_SUCCESS',
        stags: {...joinedStags, ...createdStags},
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/reducers/selectStagReducer.js